$(document).ready(function(){
$(".move-close").click(function(){
    $('.header__icon--menu .icon-close').addClass('no-z-index');
});
$(".menu-child").click(function(){
    $('.header__icon--menu .icon-close').removeClass('no-z-index');
});
$(".header__icon--menu .icon-close").click(function(){
    if($(this).hasClass('no-z-index')){
        $(this).removeClass('no-z-index');
    }
});
$(".outside-menu, .fake-close-menu").click(function(){
    $('.header__icon--menu .icon-close').trigger('click');
});
$('.use-slick').length && $('.use-slick').slick();
$('.prd-carousel').length && $('.prd-carousel').slick();
$('.ss-use-slick').length && $('.ss-use-slick').slick();
});
